import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { ICrew, ICrews, ICrewState } from "../interfaces/ICrew";



const initialState: ICrewState = {
    crew: null,
    crews: []
}

export const userSlice = createSlice({
    name: 'crew',
    initialState,
    reducers: {
        setCrewValues: (state, action: PayloadAction<ICrewState>) => {
            state.crew = action.payload.crew;
        },
        setCrews: (state, action: PayloadAction<ICrewState>) => {
            state.crews = action.payload.crews
        }
    }
})

export const {setCrewValues: setUserValues, setCrews: setUsers} = userSlice.actions;

export const selectCrew = (state: RootState) => state.crew;
export const selectCrews = (state: RootState) => state.crews;

export default userSlice.reducer;